(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  let controller;
  window.CasemetaAllProducts = {
    init(api) {
      const root = $('[data-cm-all-products]');
      if (!root || controller?.root === root) return;
      controller?.destroy();
      const listeners = new AbortController(), cache = new Map();
      const design = root.hasAttribute("data-cm-design-products");
      const ad = root.hasAttribute('data-cm-ad-products');
      const selection = design || ad;
      const pendingClass = ad ? 'cm-ad-pending' : 'cm-design-pending';
      const params = new URL(location.href).searchParams;
      const previewModel = ad && root.hasAttribute('data-ad-preview') && params.get('q')?.split('|')[2];
      const requestedModel = selection && (api.modelByLabel(params.get('cm_model')) || api.modelByLabel(params.get('filter.p.m.custom.iphone_models')) || api.modelByLabel(previewModel || window.CasemetaDesignEncodedModel) || api.getModel());
      let initialPending = !!(requestedModel && /^iPhone\b/.test(requestedModel.label) && requestedModel.label !== root.dataset.model);
      if (selection) document.documentElement.classList.toggle(pendingClass, initialPending);
      // A source page can contain many phone models of the same design. Count
      // visible, distinct slots rather than making the customer page past them.
      const batchSize = 32;
      const grid = $('[data-cm-all-grid]', root), status = $('[data-cm-all-status]', root);
      const more = $('[data-cm-all-more]', root), retry = $('[data-cm-all-retry]', root);
      let paging = JSON.parse($('[data-cm-all-page]', root).textContent), abort, revision = 0, failed, saving = false;
      let buffered = [], visibleLimit = batchSize;
      let committed = api.previewUrl(location.href);
      function updateHistory(method) {
        if (method && !window.Shopify?.designMode) history[method]({...history.state, cmAllPages: paging.page, cmAllLimit: visibleLimit}, '', committed);
      }
      const initialModel = api.modelByLabel(root.dataset.model);
      // The model encoded by a direct/ad URL wins. Home links carry the remembered model.
      if (initialModel && !selection) api.saveModel(initialModel);
      function remember(model) { saving = true; try { api.saveModel(model); } finally { saving = false; } }
      function urlFor(model) {
        if (ad) {
          const url = new URL(committed);
          // Keep the permanent campaign path and attribution parameters.
          for (const key of [...url.searchParams.keys()]) {
            if (key.startsWith('filter.') || ['page', paging.param, 'section_id', 'sort_by'].includes(key)) url.searchParams.delete(key);
          }
          url.searchParams.set('cm_model', model.label);
          if (root.hasAttribute('data-ad-preview')) url.searchParams.set('q', ['cm-ad', root.dataset.ad, model.label].join('|'));
          else url.searchParams.delete('view');
          return url;
        }
        const url = api.previewUrl(design && !root.dataset.sourceView ? root.dataset.sourceUrl : model.collection);
        if (design && root.dataset.sourceView === 'cm-design') {
          url.pathname = (window.Shopify?.routes?.root || '/') + 'search';
          url.searchParams.set('q', ['cm-design', root.dataset.source, model.label].join('|'));
        }
        if (design) { url.searchParams.set('cm_model', model.label); if (root.dataset.sourceView) url.searchParams.set('view', root.dataset.sourceView); }
        else { url.searchParams.set('view', 'cm-all'); url.searchParams.set('sort_by', 'manual'); }
        return url;
      }
      function dedupe(cards) {
        const seen = new Set();
        return cards.filter(card => { const key = card.dataset.slot; if (seen.has(key)) return false; seen.add(key); return true; });
      }
      function paint() {
        const label = $('[data-cm-all-model]', root);
        if (label) label.textContent = root.dataset.model;
        more.hidden = !paging.next && !buffered.length;
        if (!grid.children.length && !failed && !initialPending) status.textContent = paging.next ? 'Bu bölümde uygun ürün yok. Diğer ürünleri gösterebilirsin.' : 'Bu model için bu listede ürün bulunamadı.';
      }
      const initialCards = dedupe([...grid.children]);
      buffered = initialCards.slice(batchSize);
      grid.replaceChildren(...initialCards.slice(0, batchSize)); paint();
      async function page(url, number, param, signal) {
        const request = new URL(url);
        if (selection) {
          const model = api.modelByLabel(request.searchParams.get('cm_model')) || api.modelByLabel('iPhone 18 Pro Max');
          // Explicit public collection + validated phone, rendered as one section.
          request.pathname = (window.Shopify?.routes?.root || '/') + 'search';
          request.search = '';
          request.searchParams.set('q', [ad ? 'cm-ad' : 'cm-design', ad ? root.dataset.ad : root.dataset.source, model.label].join('|'));
          const preview = ad && root.hasAttribute('data-ad-preview');
          request.searchParams.set('section_id', preview ? root.dataset.sectionId : ad ? 'cm-ad-products' : 'cm-design-products');
          if (preview) request.searchParams.set('view', 'cm-ad-preview');
          const previewTheme = new URL(url).searchParams.get('preview_theme_id');
          if (previewTheme) request.searchParams.set('preview_theme_id', previewTheme);
        } else request.searchParams.set('section_id', root.dataset.sectionId);
        if (number > 1) request.searchParams.set(param, number);
        else request.searchParams.delete(param);
        const key = request.href, cached = cache.get(key);
        const parse = text => $('[data-cm-all-products]', new DOMParser().parseFromString(text, 'text/html'));
        const valid = next => next?.dataset.theme === root.dataset.theme && !next.textContent.includes('Liquid error') &&
          (!design || (next.dataset.source === root.dataset.source && next.dataset.model === (request.searchParams.get('q') || '').split('|')[2])) &&
          (!ad || (next.dataset.ad === root.dataset.ad && next.dataset.model === (request.searchParams.get('q') || '').split('|')[2]));
        let text, next;
        if (cached && Date.now() - cached.time < 30000) { text = cached.text; next = parse(text); }
        else {
          // The document already established the preview session. Repeating the
          // preview parameter adds a redirect to every section request. Verify
          // the returned theme and re-establish scope if another tab changed it.
          const direct = new URL(request); direct.searchParams.delete('preview_theme_id');
          const read = async target => {
            const response = await fetch(target, {signal});
            if (!response.ok) {
              if (response.status === 404) return '';
              throw new Error('Ürünler şu anda güncellenemedi.');
            }
            return response.text();
          };
          text = await read(direct); next = parse(text);
          if (!valid(next) && request.searchParams.has('preview_theme_id')) {
            text = await read(request); next = parse(text);
          }
          if (valid(next)) {
            cache.set(key, {time: Date.now(), text});
            if (cache.size > 24) cache.delete(cache.keys().next().value);
          }
        }
        if (!valid(next)) throw new Error('Ürünler şu anda güncellenemedi.');
        return {root: next, cards: $$('[data-cm-all-card]', next), paging: JSON.parse($('[data-cm-all-page]', next).textContent)};
      }
      async function load(url, {append = false, historyMode = 'pushState', pages = 1, limit = batchSize} = {}) {
        const ticket = ++revision;
        abort?.abort(); abort = new AbortController();
        const signal = abort.signal, timer = setTimeout(() => abort?.signal === signal && abort.abort(), 15000);
        const oldModel = api.modelByLabel(root.dataset.model);
        grid.setAttribute('aria-busy', 'true'); grid.inert = true; more.disabled = true;
        status.textContent = 'Ürünler güncelleniyor…'; retry.hidden = true; failed = null;
        try {
          let result = append ? {root, paging} : await page(url, 1, paging.param, signal);
          const needed = append ? Math.max(0, limit - grid.children.length) : limit;
          const existing = new Set(append ? [...grid.children].map(card => card.dataset.slot) : []);
          let cards = [];
          const collect = batch => {
            for (const card of batch) {
              if (existing.has(card.dataset.slot)) continue;
              existing.add(card.dataset.slot); cards.push(card);
            }
          };
          collect(append ? buffered : result.cards);
          while (result.paging.next && (cards.length < needed || (!append && result.paging.page < pages))) {
            if (ticket !== revision || signal.aborted || !root.isConnected) return;
            const previousPage = result.paging.page;
            result = await page(url, result.paging.next, result.paging.param, signal);
            if (result.paging.page <= previousPage) throw new Error('Ürün sayfası ilerlemedi.');
            collect(result.cards);
          }
          if (ticket !== revision || signal.aborted || !root.isConnected) return;
          const remainder = cards.slice(needed);
          const retained = new Map([...grid.children].map(c => [c.dataset.slot, c]));
          cards = cards.slice(0, needed).map(c => {
            const old = retained.get(c.dataset.slot);
            // Independent accessories keep their actual DOM nodes and images.
            const unchanged = old?.dataset.phone === 'false' && old.dataset.productId === c.dataset.productId &&
              old.dataset.variant === c.dataset.variant && old.textContent === c.textContent &&
              $('img', old)?.getAttribute('src') === $('img', c)?.getAttribute('src') &&
              $('[data-cm-price]', old)?.dataset.cmPrice === $('[data-cm-price]', c)?.dataset.cmPrice;
            return unchanged ? old : document.importNode(c, true);
          });
          grid.replaceChildren(...dedupe(append ? [...grid.children, ...cards] : cards));
          buffered = remainder; visibleLimit = limit;
          paging = result.paging;
          $('[data-cm-all-page]', root).textContent = JSON.stringify(paging);
          root.dataset.model = result.root.dataset.model; root.dataset.tab = result.root.dataset.tab; root.dataset.source = result.root.dataset.source;
          committed = new URL(url); committed.searchParams.delete(paging.param);
          updateHistory(historyMode);
          const model = api.modelByLabel(root.dataset.model); if (model) remember(model);
          initialPending = false;
          if (selection) document.documentElement.classList.remove(pendingClass);
          status.textContent = ''; paint();
        } catch (error) {
          if (ticket !== revision || !root.isConnected) return;
          failed = {url, append, pages, limit};
          if (initialPending) {
            // On a cold-entry failure there is no valid previous selection to show.
            // Keep the requested phone and offer retry instead of exposing default cases.
            grid.replaceChildren(); buffered = []; more.hidden = true;
            const desired = api.modelByLabel(new URL(url).searchParams.get('cm_model'));
            if (desired) remember(desired);
            status.textContent = 'Ürünler yüklenemedi. Seçtiğin model korunuyor; tekrar deneyebilirsin.';
          } else {
            if (oldModel) remember(oldModel);
            status.textContent = 'Ürünler güncellenemedi. Önceki seçim korunuyor; tekrar deneyebilirsin.';
          }
          retry.hidden = false;
          if (!historyMode) updateHistory('replaceState');
        } finally {
          clearTimeout(timer);
          if (ticket === revision) { abort = null; grid.setAttribute('aria-busy', 'false'); grid.inert = false; more.disabled = false; }
        }
      }
      root.addEventListener('click', event => {
        if (event.target.closest('[data-cm-all-more]') && (paging.next || buffered.length) && !abort) load(committed, {append:true, historyMode:'replaceState', limit:visibleLimit+batchSize});
        if (event.target.closest('[data-cm-all-retry]') && failed) { const {url, ...options} = failed; load(url, options); }
      }, {signal: listeners.signal});
      document.addEventListener('cm:model:change', event => {
        const model = event.detail;
        if (saving || !model || !/^iPhone\b/.test(model.label) || !model.collection) return;
        if (model.label !== root.dataset.model || abort) load(urlFor(model), {pages:paging.page, limit:visibleLimit});
      }, {signal: listeners.signal});
      if (!window.Shopify?.designMode) addEventListener('popstate', () => load(api.previewUrl(location.href), {historyMode:null, pages:history.state?.cmAllPages || 1, limit:history.state?.cmAllLimit || batchSize}), {signal:listeners.signal});
      controller = {root, destroy() { revision++; abort?.abort(); listeners.abort(); controller = null; }};
      root.cmReady = true;
      if (requestedModel && /^iPhone\b/.test(requestedModel.label) && requestedModel.label !== root.dataset.model) {
        load(urlFor(requestedModel), {historyMode:'replaceState'});
      } else {
        if (selection && initialModel) {
          remember(initialModel);
          committed = urlFor(initialModel);
          updateHistory('replaceState');
        }
        if (grid.children.length < batchSize && paging.next) load(committed, {append:true, historyMode:'replaceState'});
      }
    },
    destroy(scope) { if (controller && (scope === controller.root || scope.contains(controller.root))) controller.destroy(); }
  };
})();
